import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import {
  selectVisibleFlightType,
  setVisibleFlightType,
} from "../../marker/markerSlice";

function FlightTypeToggleInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const visibleFlightType = useAppSelector(selectVisibleFlightType);
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const handleToggle = () => {
    const newType = visibleFlightType === "direct" ? "connection" : "direct";
    dispatch(setVisibleFlightType(newType));
  };

  // Button shows what will be displayed after clicking
  const buttonText =
    visibleFlightType === "direct"
      ? t("FILTER_CONNECTING_FLIGHTS")
      : t("FILTER_DIRECT_FLIGHTS");

  return (
    <div className="field">
      <div className="control">
        <button
          id="flight-type-toggle-button"
          className="button is-light is-small is-align-self-flex-end flight-type-toggle-btn"
          onClick={handleToggle}
          disabled={disabled}
          type="button"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default FlightTypeToggleInput;
